import { mockGetClientMetadata } from "lib/storybook/utils"
import DegreeProgramEdit from "."
import { reactRouterNestedAncestors, reactRouterParameters } from "storybook-addon-remix-react-router"

export default {
  title: "Pages/DegreeProgram/Edit",
  component: DegreeProgramEdit,
}

const Template = () => {
  return (
    <DegreeProgramEdit />
  )
}

function buildDegreeProgramRecord(id, clientId, name, attrs = {}) {
  return {
    type: "degree-programs",
    id: id,
    attributes: {
      name: name,
      ...attrs
    },
    relationships: {
      client: { data: { type: 'clients', id: clientId } },
    }
  }
}

function buildParameters() {
  return {
    reactRouter: reactRouterParameters({
      location: {
        pathParams: {
          clientId: '1',
          degreeProgramId: '2'
        }
      },
      routing: reactRouterNestedAncestors([
        { path: 'clients' },
        { path: ':clientId' },
        { path: 'degree-programs' },
        { path: ':degreeProgramId'},
      ]),
    }),
    orbit: {
      user: {
        accessibleClientIds: ['1'],
      },
      records: [
        buildDegreeProgramRecord('2', '1', 'Dental Assistant', { programCode: 'DA', lpContinueUrl: 'https://www.somewhere.com', status: 'active'})
      ].filter(Boolean),
    },
  }
}

const Default = {
  render: Template,
  parameters: {},
}

export const ClientUser = {
  ...Default,
  parameters: buildParameters(),
}

export const WithCustomAttributes = {
  ...Default,
  parameters: {
    ...ClientUser.parameters,
    providers: {
      apollo: {
        mocks: [
          mockGetClientMetadata({
            clientIds: ['1'],
            customAttributeDefinitions: [
              { __typename: 'CustomAttributeDefinition', id: '1', entityType: 'client_campaign', key: 'ShouldNotAppear' },
              { __typename: 'CustomAttributeDefinition', id: '2', entityType: 'degree_program', key: 'Special Metric' },
              { __typename: 'CustomAttributeDefinition', id: '3', entityType: 'degree_program', key: 'Program Type' },
              { __typename: 'CustomAttributeDefinition', id: '4', entityType: 'program_group', key: 'ThisShouldAlsoNotAppear' },
            ],
          }),
        ],
      }
    },
  },
}
